query CurrentPlatform {
  currentPlatform {
    id
    title
    slug
    host
    url
    logo {
      url
    }
    description
    gaId
    googleSiteVerification
    customHTML
    customHead
    logoId
    faviconId
    iconId
    languageId
    language {
      id
      code
      title
    }
    hideableHeader
    isLikesEnabled
    isFavoritesEnabled
    isFeaturedVideosEnabled
    isVideoChatEnabled
    isStreamChatEnabled
    isComplianceEnabled
    features
    isLiveReactionsEnabled
    liveReactionPhrases
    liveReactionEmojis
    parallelPremiumViewLimit
    streamSignalAlertsEnabled
    marketingSettings {
      consentMode
      frequencyCapCount
      frequencyCapDays
      consentModeChangedAt
    }
    complianceCustodianName
    complianceCustodianAddress
    acceptTermsOfServiceOnSignIn
    defaultRowSize
    theme {
      palette {
        type
        primary
        secondary
        backgroundColor
      }
      typography {
        fontFamily
        headingFontFamily
      }
    }
    footer {
      title
      subtitle
      social {
        type
        link
      }
    }
    privacyPolicyUrl
    termsOfServiceUrl
    refundPolicyUrl
    legalEntity {
      name
      address
      registrationNumber
      email
      phone
    }
    customTerms {
      label
      url
    }
    streamingSettings {
      accountId
      apiTokenMask
      connectedAt
    }
    effectiveVideoProvider
    bunnySettings {
      libraryId
      cdnHostname
      apiKeyMask
      connectedAt
    }
    paymentSettings {
      publishableKey
      secretKeyMask
      connectedAt
      paynet {
        merchantCode
        secretKeyMask
        saleArea
        connectedAt
      }
      ccbill {
        accnum
        subaccount
        flexFormId
        saltMask
        webhookUrl
        supportUrl
        sandbox
        connectedAt
      }
      paypal {
        clientId
        webhookUrl
        sandbox
        connectedAt
      }
      provider
    }
    domainSetup {
      host
      status
      provider
      zoneName
      manualRecords {
        type
        name
        value
      }
      dnsManaged
      lastError
      previousStatus
      statusChangedAt
      updatedAt
      activatedAt
    }
    streamingAvailable
  }
}
